import { Injectable } from '@angular/core';
import { CustomToastsService } from './custom-toasts.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(private toastr: CustomToastsService) { }

  getErrorMessage(err: any): boolean {
    if (!err) return true; // No error, safe to close

    // For validation errors (400), keep dialog open so user can fix them
    if (err.status === 400 && err.error?.errors?.length) {
      // Process all validation errors
      if (err.error.errors.length === 1) {
        // Single error - simple message
        const error = err.error.errors[0];
        const validationMessage = `${error.field}: ${error.message}`;
        this.toastr.clientError(validationMessage, 400);
      } else {
        // Multiple errors - format as list
        const validationMessages = err.error.errors
          .map((error: any) => `• ${error.field}: ${error.message}`)
          .join('\n');

        this.toastr.clientError(`${validationMessages}`, 400);
      }
      return false; // Don't close - user needs to fix validation errors
    }
    // For unauthorized/forbidden, redirect happens in interceptor
    else if (err.status === 401 || err.status === 403) {
      // No need for toast since interceptor handles these
      return true; // Close dialog as user will be redirected
    }
    // For server errors, display message
    else if (err.status === 500) {
      this.toastr.serverError(
        'Server error (500): An unexpected error occurred. Please check logs or contact the administrator.',
        500,
      );
      return true; // Close dialog as nothing can be fixed here
    }
    // For all other errors
    else {
      // Use clientError or serverError based on status code
      if (err.status >= 400 && err.status < 500) {
        this.toastr.clientError(
          err.error?.detail || 'Oops! Something went wrong. Please try again.',
          err.status,
        );
      } else {
        this.toastr.serverError(
          err.error?.detail || 'A server error occurred. Please try again later.',
          err.status || 500,
        );
      }
      return true; // Close dialog by default for other errors
    }
  }

  handleFormError(err: any, formName?: string): boolean {
    return this.getErrorMessage(err);
  }

  handleDeleteError(err: any, itemName?: string): void {
    this.getErrorMessage(err);
  }
}
